import { CheckCheck, Info } from "lucide-react";
import React from "react";
import Badge from "../UI/Badge";
import Skeleton from "react-loading-skeleton";

export default function ReferralPracticeDataTable(props) {
  const {
    tableData = [],
    dataLoading,
    setCheckPracticeData = () => {},
    toggleAccordion = () => {},
    referPatientData = {},
    setReferPatientData = () => {},
  } = props;

  const selectSpecialist = (item, id) => {
    setCheckPracticeData(item);
    toggleAccordion(2);
    setReferPatientData({
      ...referPatientData,
      refer_to_npi: item?.npi,
      refer_to_state: item?.provider_business_mailing_address_state_name,
      refer_to_specialty_id: id
    });
  }

  return (
    <>
      <div className="docpro_table_responsive" style={{ minHeight: "250px" }}>
        <table className="docpro_mb_0" style={{ height: "100%" }}>
          <thead>
            <tr>
              <th>Specialty</th>
              <th>Practice & Provider Name</th>
              <th>Practice Address</th>
              <th className="docpro_text_center">Action</th>
            </tr>
          </thead>
          <tbody>
            {!dataLoading ? (
              tableData.length > 0 ? (
                tableData?.map((item, index) => (
                  item?.specialities?.map((element, spIndex) => (
                    <tr key={`${index}-${spIndex}`} className={`row_${item.id}`}>
                      <td>
                        <Badge color="cyan" variant="docpro_fs_12">
                          {element.name}
                        </Badge>
                      </td>
                      <td>
                        <div className="docpro_table_info_list_md">
                          <p className="docpro_mb_0">
                            <b>Practice: </b> {item?.provider_organization_name}
                          </p>
                          <p className="docpro_mb_0">
                            <b>Authorized: </b> {item?.authorized_official_first_name}{' '}
                            {item?.authorized_official_middle_name}{' '}
                            {item?.authorized_official_last_name}{' ('}
                            {item?.authorized_official_title_or_position}{')'}
                          </p>
                        </div>
                      </td>
                      <td>
                        <div className="docpro_table_info_list_md">
                          {item?.provider_first_line_business_practice_location_address}, 
                          {item?.provider_business_practice_location_address_city_name}, 
                          {item?.provider_business_practice_location_address_state_name} 
                          {item?.provider_business_practice_location_address_postal_code?.slice(0, 6)}
                        </div>
                      </td>
                      <td className="docpro_text_center">
                        <div className="docpro_icon_btns" phone={item?.provider_business_practice_location_address_telephone_number}>
                          <button
                            type="button"
                            className={`docpro_bordered_btn docpro_fw_600 docpro_tip_checkbox last_btn_tip ${item?.accept_insurance?.length === 0 ? 'docpro_badge_orange' : 'docpro_filed_btn'}`}
                            onClick={() => selectSpecialist(item, element?.id)}
                          >
                            {item?.accept_insurance?.length === 0 ?
                              <>
                                <Info width={16} height={16} />
                                <span className="docpro_tip">Practice is not registered</span>
                              </>
                            :
                              <>
                                <CheckCheck width={18} height={18} />
                                <span className="docpro_tip">Practice is registered</span>
                              </>
                            }
                            <span>Select</span>
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))
                ))
              ) : (
                <tr>
                  <td className="no_data docpro_p_0" style={{ height: "250px" }} colSpan="4">
                    No data available
                  </td>
                </tr>
              )
            ) : (
              Array.from({ length: 8 }).map((_, index) => (
                <tr key={index} style={{ height: '50px' }}>
                  <td> <Skeleton width={`${6 + (index % 2)}rem`} borderRadius="8px"></Skeleton> </td>
                  <td>
                    <Skeleton width={`${6 + (index % 2)}rem`} borderRadius="8px"></Skeleton>
                    <Skeleton width={`${5 + (index % 2.5)}rem`} borderRadius="8px"></Skeleton>
                  </td>
                  <td> <Skeleton width={`${4 + (index % 1.5)}rem`} borderRadius="8px"></Skeleton> </td>
                  <td className="text-center"> <Skeleton width="4rem" borderRadius="8px"></Skeleton> </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </>
  );
}
